export default [
  {
    "value": "11",
    "label": "北京市",
    "children": [
      {
        "value": "110101",
        "label": "东城区"
      },
      {
        "value": "110102",
        "label": "西城区"
      },
      {
        "value": "110105",
        "label": "朝阳区"
      },
      {
        "value": "110106",
        "label": "丰台区"
      },
      {
        "value": "110107",
        "label": "石景山区"
      },
      {
        "value": "110108",
        "label": "海淀区"
      },
      {
        "value": "110109",
        "label": "门头沟区"
      },
      {
        "value": "110111",
        "label": "房山区"
      },
      {
        "value": "110112",
        "label": "通州区"
      },
      {
        "value": "110113",
        "label": "顺义区"
      },
      {
        "value": "110114",
        "label": "昌平区"
      },
      {
        "value": "110115",
        "label": "大兴区"
      },
      {
        "value": "110116",
        "label": "怀柔区"
      },
      {
        "value": "110117",
        "label": "平谷区"
      },
      {
        "value": "110118",
        "label": "密云区"
      },
      {
        "value": "110119",
        "label": "延庆区"
      }
    ]
  },
  {
    "value": "12",
    "label": "天津市",
    "children": [
      {
        "value": "120101",
        "label": "和平区"
      },
      {
        "value": "120102",
        "label": "河东区"
      },
      {
        "value": "120103",
        "label": "河西区"
      },
      {
        "value": "120104",
        "label": "南开区"
      },
      {
        "value": "120105",
        "label": "河北区"
      },
      {
        "value": "120106",
        "label": "红桥区"
      },
      {
        "value": "120110",
        "label": "东丽区"
      },
      {
        "value": "120111",
        "label": "西青区"
      },
      {
        "value": "120112",
        "label": "津南区"
      },
      {
        "value": "120113",
        "label": "北辰区"
      },
      {
        "value": "120114",
        "label": "武清区"
      },
      {
        "value": "120115",
        "label": "宝坻区"
      },
      {
        "value": "120116",
        "label": "滨海新区"
      },
      {
        "value": "120117",
        "label": "宁河区"
      },
      {
        "value": "120118",
        "label": "静海区"
      },
      {
        "value": "120119",
        "label": "蓟州区"
      }
    ]
  },
  {
    "value": "13",
    "label": "河北省",
    "children": [
      {
        "value": "1301",
        "label": "石家庄市"
      },
      {
        "value": "1302",
        "label": "唐山市"
      },
      {
        "value": "1303",
        "label": "秦皇岛市"
      },
      {
        "value": "1304",
        "label": "邯郸市"
      },
      {
        "value": "1305",
        "label": "邢台市"
      },
      {
        "value": "1306",
        "label": "保定市"
      },
      {
        "value": "1307",
        "label": "张家口市"
      },
      {
        "value": "1308",
        "label": "承德市"
      },
      {
        "value": "1309",
        "label": "沧州市"
      },
      {
        "value": "1310",
        "label": "廊坊市"
      },
      {
        "value": "1311",
        "label": "衡水市"
      }
    ]
  },
  {
    "value": "14",
    "label": "山西省",
    "children": [
      {
        "value": "1401",
        "label": "太原市"
      },
      {
        "value": "1402",
        "label": "大同市"
      },
      {
        "value": "1403",
        "label": "阳泉市"
      },
      {
        "value": "1404",
        "label": "长治市"
      },
      {
        "value": "1405",
        "label": "晋城市"
      },
      {
        "value": "1406",
        "label": "朔州市"
      },
      {
        "value": "1407",
        "label": "晋中市"
      },
      {
        "value": "1408",
        "label": "运城市"
      },
      {
        "value": "1409",
        "label": "忻州市"
      },
      {
        "value": "1410",
        "label": "临汾市"
      },
      {
        "value": "1411",
        "label": "吕梁市"
      }
    ]
  },
  {
    "value": "15",
    "label": "内蒙古自治区",
    "children": [
      {
        "value": "1501",
        "label": "呼和浩特市"
      },
      {
        "value": "1502",
        "label": "包头市"
      },
      {
        "value": "1503",
        "label": "乌海市"
      },
      {
        "value": "1504",
        "label": "赤峰市"
      },
      {
        "value": "1505",
        "label": "通辽市"
      },
      {
        "value": "1506",
        "label": "鄂尔多斯市"
      },
      {
        "value": "1507",
        "label": "呼伦贝尔市"
      },
      {
        "value": "1508",
        "label": "巴彦淖尔市"
      },
      {
        "value": "1509",
        "label": "乌兰察布市"
      },
      {
        "value": "1522",
        "label": "兴安盟"
      },
      {
        "value": "1525",
        "label": "锡林郭勒盟"
      },
      {
        "value": "1529",
        "label": "阿拉善盟"
      }
    ]
  },
  {
    "value": "21",
    "label": "辽宁省",
    "children": [
      {
        "value": "2101",
        "label": "沈阳市"
      },
      {
        "value": "2102",
        "label": "大连市"
      },
      {
        "value": "2103",
        "label": "鞍山市"
      },
      {
        "value": "2104",
        "label": "抚顺市"
      },
      {
        "value": "2105",
        "label": "本溪市"
      },
      {
        "value": "2106",
        "label": "丹东市"
      },
      {
        "value": "2107",
        "label": "锦州市"
      },
      {
        "value": "2108",
        "label": "营口市"
      },
      {
        "value": "2109",
        "label": "阜新市"
      },
      {
        "value": "2110",
        "label": "辽阳市"
      },
      {
        "value": "2111",
        "label": "盘锦市"
      },
      {
        "value": "2112",
        "label": "铁岭市"
      },
      {
        "value": "2113",
        "label": "朝阳市"
      },
      {
        "value": "2114",
        "label": "葫芦岛市"
      }
    ]
  },
  {
    "value": "22",
    "label": "吉林省",
    "children": [
      {
        "value": "2201",
        "label": "长春市"
      },
      {
        "value": "2202",
        "label": "吉林市"
      },
      {
        "value": "2203",
        "label": "四平市"
      },
      {
        "value": "2204",
        "label": "辽源市"
      },
      {
        "value": "2205",
        "label": "通化市"
      },
      {
        "value": "2206",
        "label": "白山市"
      },
      {
        "value": "2207",
        "label": "松原市"
      },
      {
        "value": "2208",
        "label": "白城市"
      },
      {
        "value": "2224",
        "label": "延边朝鲜族自治州"
      }
    ]
  },
  {
    "value": "23",
    "label": "黑龙江省",
    "children": [
      {
        "value": "2301",
        "label": "哈尔滨市"
      },
      {
        "value": "2302",
        "label": "齐齐哈尔市"
      },
      {
        "value": "2303",
        "label": "鸡西市"
      },
      {
        "value": "2304",
        "label": "鹤岗市"
      },
      {
        "value": "2305",
        "label": "双鸭山市"
      },
      {
        "value": "2306",
        "label": "大庆市"
      },
      {
        "value": "2307",
        "label": "伊春市"
      },
      {
        "value": "2308",
        "label": "佳木斯市"
      },
      {
        "value": "2309",
        "label": "七台河市"
      },
      {
        "value": "2310",
        "label": "牡丹江市"
      },
      {
        "value": "2311",
        "label": "黑河市"
      },
      {
        "value": "2312",
        "label": "绥化市"
      },
      {
        "value": "2327",
        "label": "大兴安岭地区"
      }
    ]
  },
  {
    "value": "31",
    "label": "上海市",
    "children": [
      {
        "value": "310101",
        "label": "黄浦区"
      },
      {
        "value": "310104",
        "label": "徐汇区"
      },
      {
        "value": "310105",
        "label": "长宁区"
      },
      {
        "value": "310106",
        "label": "静安区"
      },
      {
        "value": "310107",
        "label": "普陀区"
      },
      {
        "value": "310109",
        "label": "虹口区"
      },
      {
        "value": "310110",
        "label": "杨浦区"
      },
      {
        "value": "310112",
        "label": "闵行区"
      },
      {
        "value": "310113",
        "label": "宝山区"
      },
      {
        "value": "310114",
        "label": "嘉定区"
      },
      {
        "value": "310115",
        "label": "浦东新区"
      },
      {
        "value": "310116",
        "label": "金山区"
      },
      {
        "value": "310117",
        "label": "松江区"
      },
      {
        "value": "310118",
        "label": "青浦区"
      },
      {
        "value": "310120",
        "label": "奉贤区"
      },
      {
        "value": "310151",
        "label": "崇明区"
      }
    ]
  },
  {
    "value": "32",
    "label": "江苏省",
    "enable": true,
    "children": [
      {
        "value": "3201",
        "label": "南京市"
      },
      {
        "value": "3202",
        "label": "无锡市"
      },
      {
        "value": "3203",
        "label": "徐州市"
      },
      {
        "value": "3204",
        "label": "常州市"
      },
      {
        "value": "3205",
        "label": "苏州市"
      },
      {
        "value": "3206",
        "label": "南通市"
      },
      {
        "value": "3207",
        "label": "连云港市"
      },
      {
        "value": "3208",
        "label": "淮安市"
      },
      {
        "value": "3209",
        "label": "盐城市"
      },
      {
        "value": "3210",
        "label": "扬州市"
      },
      {
        "value": "3211",
        "label": "镇江市"
      },
      {
        "value": "3212",
        "label": "泰州市"
      },
      {
        "value": "3213",
        "label": "宿迁市"
      }
    ]
  },
  {
    "value": "33",
    "label": "浙江省",
    "children": [
      {
        "value": "3301",
        "label": "杭州市"
      },
      {
        "value": "3302",
        "label": "宁波市"
      },
      {
        "value": "3303",
        "label": "温州市"
      },
      {
        "value": "3304",
        "label": "嘉兴市"
      },
      {
        "value": "3305",
        "label": "湖州市"
      },
      {
        "value": "3306",
        "label": "绍兴市"
      },
      {
        "value": "3307",
        "label": "金华市"
      },
      {
        "value": "3308",
        "label": "衢州市"
      },
      {
        "value": "3309",
        "label": "舟山市"
      },
      {
        "value": "3310",
        "label": "台州市"
      },
      {
        "value": "3311",
        "label": "丽水市"
      }
    ]
  },
  {
    "value": "34",
    "label": "安徽省",
    "enable": true,
    "children": [
      {
        "value": "3401",
        "label": "合肥市"
      },
      {
        "value": "3402",
        "label": "芜湖市"
      },
      {
        "value": "3403",
        "label": "蚌埠市"
      },
      {
        "value": "3404",
        "label": "淮南市"
      },
      {
        "value": "3405",
        "label": "马鞍山市"
      },
      {
        "value": "3406",
        "label": "淮北市"
      },
      {
        "value": "3407",
        "label": "铜陵市"
      },
      {
        "value": "3408",
        "label": "安庆市"
      },
      {
        "value": "3410",
        "label": "黄山市"
      },
      {
        "value": "3411",
        "label": "滁州市"
      },
      {
        "value": "3412",
        "label": "阜阳市"
      },
      {
        "value": "3413",
        "label": "宿州市"
      },
      {
        "value": "3415",
        "label": "六安市"
      },
      {
        "value": "3416",
        "label": "亳州市"
      },
      {
        "value": "3417",
        "label": "池州市"
      },
      {
        "value": "3418",
        "label": "宣城市"
      }
    ]
  },
  {
    "value": "35",
    "label": "福建省",
    "children": [
      {
        "value": "3501",
        "label": "福州市"
      },
      {
        "value": "3502",
        "label": "厦门市"
      },
      {
        "value": "3503",
        "label": "莆田市"
      },
      {
        "value": "3504",
        "label": "三明市"
      },
      {
        "value": "3505",
        "label": "泉州市"
      },
      {
        "value": "3506",
        "label": "漳州市"
      },
      {
        "value": "3507",
        "label": "南平市"
      },
      {
        "value": "3508",
        "label": "龙岩市"
      },
      {
        "value": "3509",
        "label": "宁德市"
      }
    ]
  },
  {
    "value": "36",
    "label": "江西省",
    "children": [
      {
        "value": "3601",
        "label": "南昌市"
      },
      {
        "value": "3602",
        "label": "景德镇市"
      },
      {
        "value": "3603",
        "label": "萍乡市"
      },
      {
        "value": "3604",
        "label": "九江市"
      },
      {
        "value": "3605",
        "label": "新余市"
      },
      {
        "value": "3606",
        "label": "鹰潭市"
      },
      {
        "value": "3607",
        "label": "赣州市"
      },
      {
        "value": "3608",
        "label": "吉安市"
      },
      {
        "value": "3609",
        "label": "宜春市"
      },
      {
        "value": "3610",
        "label": "抚州市"
      },
      {
        "value": "3611",
        "label": "上饶市"
      }
    ]
  },
  {
    "value": "37",
    "label": "山东省",
    "children": [
      {
        "value": "3701",
        "label": "济南市"
      },
      {
        "value": "3702",
        "label": "青岛市"
      },
      {
        "value": "3703",
        "label": "淄博市"
      },
      {
        "value": "3704",
        "label": "枣庄市"
      },
      {
        "value": "3705",
        "label": "东营市"
      },
      {
        "value": "3706",
        "label": "烟台市"
      },
      {
        "value": "3707",
        "label": "潍坊市"
      },
      {
        "value": "3708",
        "label": "济宁市"
      },
      {
        "value": "3709",
        "label": "泰安市"
      },
      {
        "value": "3710",
        "label": "威海市"
      },
      {
        "value": "3711",
        "label": "日照市"
      },
      {
        "value": "3713",
        "label": "临沂市"
      },
      {
        "value": "3714",
        "label": "德州市"
      },
      {
        "value": "3715",
        "label": "聊城市"
      },
      {
        "value": "3716",
        "label": "滨州市"
      },
      {
        "value": "3717",
        "label": "菏泽市"
      }
    ]
  },
  {
    "value": "41",
    "label": "河南省",
    "enable": true,
    "children": [
      {
        "value": "4101",
        "label": "郑州市"
      },
      {
        "value": "4102",
        "label": "开封市"
      },
      {
        "value": "4103",
        "label": "洛阳市"
      },
      {
        "value": "4104",
        "label": "平顶山市"
      },
      {
        "value": "4105",
        "label": "安阳市"
      },
      {
        "value": "4106",
        "label": "鹤壁市"
      },
      {
        "value": "4107",
        "label": "新乡市"
      },
      {
        "value": "4108",
        "label": "焦作市"
      },
      {
        "value": "4109",
        "label": "濮阳市"
      },
      {
        "value": "4110",
        "label": "许昌市"
      },
      {
        "value": "4111",
        "label": "漯河市"
      },
      {
        "value": "4112",
        "label": "三门峡市"
      },
      {
        "value": "4113",
        "label": "南阳市"
      },
      {
        "value": "4114",
        "label": "商丘市"
      },
      {
        "value": "4115",
        "label": "信阳市"
      },
      {
        "value": "4116",
        "label": "周口市"
      },
      {
        "value": "4117",
        "label": "驻马店市"
      },
      {
        "value": "419001",
        "label": "济源市"
      }
    ]
  },
  {
    "value": "42",
    "label": "湖北省",
    "enable": true,
    "children": [
      {
        "value": "4201",
        "label": "武汉市"
      },
      {
        "value": "4202",
        "label": "黄石市"
      },
      {
        "value": "4203",
        "label": "十堰市"
      },
      {
        "value": "4205",
        "label": "宜昌市"
      },
      {
        "value": "4206",
        "label": "襄阳市"
      },
      {
        "value": "4207",
        "label": "鄂州市"
      },
      {
        "value": "4208",
        "label": "荆门市"
      },
      {
        "value": "4209",
        "label": "孝感市"
      },
      {
        "value": "4210",
        "label": "荆州市"
      },
      {
        "value": "4211",
        "label": "黄冈市"
      },
      {
        "value": "4212",
        "label": "咸宁市"
      },
      {
        "value": "4213",
        "label": "随州市"
      },
      {
        "value": "4228",
        "label": "恩施土家族苗族自治州"
      },
      {
        "value": "429004",
        "label": "仙桃市"
      },
      {
        "value": "429005",
        "label": "潜江市"
      },
      {
        "value": "429006",
        "label": "天门市"
      },
      {
        "value": "429021",
        "label": "神农架林区"
      }
    ]
  },
  {
    "value": "43",
    "label": "湖南省",
    "children": [
      {
        "value": "4301",
        "label": "长沙市"
      },
      {
        "value": "4302",
        "label": "株洲市"
      },
      {
        "value": "4303",
        "label": "湘潭市"
      },
      {
        "value": "4304",
        "label": "衡阳市"
      },
      {
        "value": "4305",
        "label": "邵阳市"
      },
      {
        "value": "4306",
        "label": "岳阳市"
      },
      {
        "value": "4307",
        "label": "常德市"
      },
      {
        "value": "4308",
        "label": "张家界市"
      },
      {
        "value": "4309",
        "label": "益阳市"
      },
      {
        "value": "4310",
        "label": "郴州市"
      },
      {
        "value": "4311",
        "label": "永州市"
      },
      {
        "value": "4312",
        "label": "怀化市"
      },
      {
        "value": "4313",
        "label": "娄底市"
      },
      {
        "value": "4331",
        "label": "湘西土家族苗族自治州"
      }
    ]
  },
  {
    "value": "44",
    "label": "广东省",
    "children": [
      {
        "value": "4401",
        "label": "广州市"
      },
      {
        "value": "4402",
        "label": "韶关市"
      },
      {
        "value": "4403",
        "label": "深圳市"
      },
      {
        "value": "4404",
        "label": "珠海市"
      },
      {
        "value": "4405",
        "label": "汕头市"
      },
      {
        "value": "4406",
        "label": "佛山市"
      },
      {
        "value": "4407",
        "label": "江门市"
      },
      {
        "value": "4408",
        "label": "湛江市"
      },
      {
        "value": "4409",
        "label": "茂名市"
      },
      {
        "value": "4412",
        "label": "肇庆市"
      },
      {
        "value": "4413",
        "label": "惠州市"
      },
      {
        "value": "4414",
        "label": "梅州市"
      },
      {
        "value": "4415",
        "label": "汕尾市"
      },
      {
        "value": "4416",
        "label": "河源市"
      },
      {
        "value": "4417",
        "label": "阳江市"
      },
      {
        "value": "4418",
        "label": "清远市"
      },
      {
        "value": "4419",
        "label": "东莞市"
      },
      {
        "value": "4420",
        "label": "中山市"
      },
      {
        "value": "4451",
        "label": "潮州市"
      },
      {
        "value": "4452",
        "label": "揭阳市"
      },
      {
        "value": "4453",
        "label": "云浮市"
      }
    ]
  },
  {
    "value": "45",
    "label": "广西壮族自治区",
    "children": [
      {
        "value": "4501",
        "label": "南宁市"
      },
      {
        "value": "4502",
        "label": "柳州市"
      },
      {
        "value": "4503",
        "label": "桂林市"
      },
      {
        "value": "4504",
        "label": "梧州市"
      },
      {
        "value": "4505",
        "label": "北海市"
      },
      {
        "value": "4506",
        "label": "防城港市"
      },
      {
        "value": "4507",
        "label": "钦州市"
      },
      {
        "value": "4508",
        "label": "贵港市"
      },
      {
        "value": "4509",
        "label": "玉林市"
      },
      {
        "value": "4510",
        "label": "百色市"
      },
      {
        "value": "4511",
        "label": "贺州市"
      },
      {
        "value": "4512",
        "label": "河池市"
      },
      {
        "value": "4513",
        "label": "来宾市"
      },
      {
        "value": "4514",
        "label": "崇左市"
      }
    ]
  },
  {
    "value": "46",
    "label": "海南省",
    "children": [
      {
        "value": "4601",
        "label": "海口市"
      },
      {
        "value": "4602",
        "label": "三亚市"
      },
      {
        "value": "4603",
        "label": "三沙市"
      },
      {
        "value": "4604",
        "label": "儋州市"
      },
      {
        "value": "469001",
        "label": "五指山市"
      },
      {
        "value": "469002",
        "label": "琼海市"
      },
      {
        "value": "469005",
        "label": "文昌市"
      },
      {
        "value": "469006",
        "label": "万宁市"
      },
      {
        "value": "469007",
        "label": "东方市"
      },
      {
        "value": "469021",
        "label": "定安县"
      },
      {
        "value": "469022",
        "label": "屯昌县"
      },
      {
        "value": "469023",
        "label": "澄迈县"
      },
      {
        "value": "469024",
        "label": "临高县"
      },
      {
        "value": "469025",
        "label": "白沙黎族自治县"
      },
      {
        "value": "469026",
        "label": "昌江黎族自治县"
      },
      {
        "value": "469027",
        "label": "乐东黎族自治县"
      },
      {
        "value": "469028",
        "label": "陵水黎族自治县"
      },
      {
        "value": "469029",
        "label": "保亭黎族苗族自治县"
      },
      {
        "value": "469030",
        "label": "琼中黎族苗族自治县"
      }
    ]
  },
  {
    "value": "50",
    "label": "重庆市",
    "children": [
      {
        "value": "500101",
        "label": "万州区"
      },
      {
        "value": "500102",
        "label": "涪陵区"
      },
      {
        "value": "500103",
        "label": "渝中区"
      },
      {
        "value": "500104",
        "label": "大渡口区"
      },
      {
        "value": "500105",
        "label": "江北区"
      },
      {
        "value": "500106",
        "label": "沙坪坝区"
      },
      {
        "value": "500107",
        "label": "九龙坡区"
      },
      {
        "value": "500108",
        "label": "南岸区"
      },
      {
        "value": "500109",
        "label": "北碚区"
      },
      {
        "value": "500110",
        "label": "綦江区"
      },
      {
        "value": "500111",
        "label": "大足区"
      },
      {
        "value": "500112",
        "label": "渝北区"
      },
      {
        "value": "500113",
        "label": "巴南区"
      },
      {
        "value": "500114",
        "label": "黔江区"
      },
      {
        "value": "500115",
        "label": "长寿区"
      },
      {
        "value": "500116",
        "label": "江津区"
      },
      {
        "value": "500117",
        "label": "合川区"
      },
      {
        "value": "500118",
        "label": "永川区"
      },
      {
        "value": "500119",
        "label": "南川区"
      },
      {
        "value": "500120",
        "label": "璧山区"
      },
      {
        "value": "500151",
        "label": "铜梁区"
      },
      {
        "value": "500152",
        "label": "潼南区"
      },
      {
        "value": "500153",
        "label": "荣昌区"
      },
      {
        "value": "500154",
        "label": "开州区"
      },
      {
        "value": "500155",
        "label": "梁平区"
      },
      {
        "value": "500156",
        "label": "武隆区"
      },
      {
        "value": "500229",
        "label": "城口县"
      },
      {
        "value": "500230",
        "label": "丰都县"
      },
      {
        "value": "500231",
        "label": "垫江县"
      },
      {
        "value": "500233",
        "label": "忠县"
      },
      {
        "value": "500235",
        "label": "云阳县"
      },
      {
        "value": "500236",
        "label": "奉节县"
      },
      {
        "value": "500237",
        "label": "巫山县"
      },
      {
        "value": "500238",
        "label": "巫溪县"
      },
      {
        "value": "500240",
        "label": "石柱土家族自治县"
      },
      {
        "value": "500241",
        "label": "秀山土家族苗族自治县"
      },
      {
        "value": "500242",
        "label": "酉阳土家族苗族自治县"
      },
      {
        "value": "500243",
        "label": "彭水苗族土家族自治县"
      }
    ]
  },
  {
    "value": "51",
    "label": "四川省",
    "children": [
      {
        "value": "5101",
        "label": "成都市"
      },
      {
        "value": "5103",
        "label": "自贡市"
      },
      {
        "value": "5104",
        "label": "攀枝花市"
      },
      {
        "value": "5105",
        "label": "泸州市"
      },
      {
        "value": "5106",
        "label": "德阳市"
      },
      {
        "value": "5107",
        "label": "绵阳市"
      },
      {
        "value": "5108",
        "label": "广元市"
      },
      {
        "value": "5109",
        "label": "遂宁市"
      },
      {
        "value": "5110",
        "label": "内江市"
      },
      {
        "value": "5111",
        "label": "乐山市"
      },
      {
        "value": "5113",
        "label": "南充市"
      },
      {
        "value": "5114",
        "label": "眉山市"
      },
      {
        "value": "5115",
        "label": "宜宾市"
      },
      {
        "value": "5116",
        "label": "广安市"
      },
      {
        "value": "5117",
        "label": "达州市"
      },
      {
        "value": "5118",
        "label": "雅安市"
      },
      {
        "value": "5119",
        "label": "巴中市"
      },
      {
        "value": "5120",
        "label": "资阳市"
      },
      {
        "value": "5132",
        "label": "阿坝藏族羌族自治州"
      },
      {
        "value": "5133",
        "label": "甘孜藏族自治州"
      },
      {
        "value": "5134",
        "label": "凉山彝族自治州"
      }
    ]
  },
  {
    "value": "52",
    "label": "贵州省",
    "children": [
      {
        "value": "5201",
        "label": "贵阳市"
      },
      {
        "value": "5202",
        "label": "六盘水市"
      },
      {
        "value": "5203",
        "label": "遵义市"
      },
      {
        "value": "5204",
        "label": "安顺市"
      },
      {
        "value": "5205",
        "label": "毕节市"
      },
      {
        "value": "5206",
        "label": "铜仁市"
      },
      {
        "value": "5223",
        "label": "黔西南布依族苗族自治州"
      },
      {
        "value": "5226",
        "label": "黔东南苗族侗族自治州"
      },
      {
        "value": "5227",
        "label": "黔南布依族苗族自治州"
      }
    ]
  },
  {
    "value": "53",
    "label": "云南省",
    "children": [
      {
        "value": "5301",
        "label": "昆明市"
      },
      {
        "value": "5303",
        "label": "曲靖市"
      },
      {
        "value": "5304",
        "label": "玉溪市"
      },
      {
        "value": "5305",
        "label": "保山市"
      },
      {
        "value": "5306",
        "label": "昭通市"
      },
      {
        "value": "5307",
        "label": "丽江市"
      },
      {
        "value": "5308",
        "label": "普洱市"
      },
      {
        "value": "5309",
        "label": "临沧市"
      },
      {
        "value": "5323",
        "label": "楚雄彝族自治州"
      },
      {
        "value": "5325",
        "label": "红河哈尼族彝族自治州"
      },
      {
        "value": "5326",
        "label": "文山壮族苗族自治州"
      },
      {
        "value": "5328",
        "label": "西双版纳傣族自治州"
      },
      {
        "value": "5329",
        "label": "大理白族自治州"
      },
      {
        "value": "5331",
        "label": "德宏傣族景颇族自治州"
      },
      {
        "value": "5333",
        "label": "怒江傈僳族自治州"
      },
      {
        "value": "5334",
        "label": "迪庆藏族自治州"
      }
    ]
  },
  {
    "value": "54",
    "label": "西藏自治区",
    "children": [
      {
        "value": "5401",
        "label": "拉萨市"
      },
      {
        "value": "5402",
        "label": "日喀则市"
      },
      {
        "value": "5403",
        "label": "昌都市"
      },
      {
        "value": "5404",
        "label": "林芝市"
      },
      {
        "value": "5405",
        "label": "山南市"
      },
      {
        "value": "5406",
        "label": "那曲市"
      },
      {
        "value": "5425",
        "label": "阿里地区"
      }
    ]
  },
  {
    "value": "61",
    "label": "陕西省",
    "children": [
      {
        "value": "6101",
        "label": "西安市"
      },
      {
        "value": "6102",
        "label": "铜川市"
      },
      {
        "value": "6103",
        "label": "宝鸡市"
      },
      {
        "value": "6104",
        "label": "咸阳市"
      },
      {
        "value": "6105",
        "label": "渭南市"
      },
      {
        "value": "6106",
        "label": "延安市"
      },
      {
        "value": "6107",
        "label": "汉中市"
      },
      {
        "value": "6108",
        "label": "榆林市"
      },
      {
        "value": "6109",
        "label": "安康市"
      },
      {
        "value": "6110",
        "label": "商洛市"
      }
    ]
  },
  {
    "value": "62",
    "label": "甘肃省",
    "children": [
      {
        "value": "6201",
        "label": "兰州市"
      },
      {
        "value": "6202",
        "label": "嘉峪关市"
      },
      {
        "value": "6203",
        "label": "金昌市"
      },
      {
        "value": "6204",
        "label": "白银市"
      },
      {
        "value": "6205",
        "label": "天水市"
      },
      {
        "value": "6206",
        "label": "武威市"
      },
      {
        "value": "6207",
        "label": "张掖市"
      },
      {
        "value": "6208",
        "label": "平凉市"
      },
      {
        "value": "6209",
        "label": "酒泉市"
      },
      {
        "value": "6210",
        "label": "庆阳市"
      },
      {
        "value": "6211",
        "label": "定西市"
      },
      {
        "value": "6212",
        "label": "陇南市"
      },
      {
        "value": "6229",
        "label": "临夏回族自治州"
      },
      {
        "value": "6230",
        "label": "甘南藏族自治州"
      }
    ]
  },
  {
    "value": "63",
    "label": "青海省",
    "children": [
      {
        "value": "6301",
        "label": "西宁市"
      },
      {
        "value": "6302",
        "label": "海东市"
      },
      {
        "value": "6322",
        "label": "海北藏族自治州"
      },
      {
        "value": "6323",
        "label": "黄南藏族自治州"
      },
      {
        "value": "6325",
        "label": "海南藏族自治州"
      },
      {
        "value": "6326",
        "label": "果洛藏族自治州"
      },
      {
        "value": "6327",
        "label": "玉树藏族自治州"
      },
      {
        "value": "6328",
        "label": "海西蒙古族藏族自治州"
      }
    ]
  },
  {
    "value": "64",
    "label": "宁夏回族自治区",
    "children": [
      {
        "value": "6401",
        "label": "银川市"
      },
      {
        "value": "6402",
        "label": "石嘴山市"
      },
      {
        "value": "6403",
        "label": "吴忠市"
      },
      {
        "value": "6404",
        "label": "固原市"
      },
      {
        "value": "6405",
        "label": "中卫市"
      }
    ]
  },
  {
    "value": "65",
    "label": "新疆维吾尔自治区",
    "children": [
      {
        "value": "6501",
        "label": "乌鲁木齐市"
      },
      {
        "value": "6502",
        "label": "克拉玛依市"
      },
      {
        "value": "6504",
        "label": "吐鲁番市"
      },
      {
        "value": "6505",
        "label": "哈密市"
      },
      {
        "value": "6523",
        "label": "昌吉回族自治州"
      },
      {
        "value": "6527",
        "label": "博尔塔拉蒙古自治州"
      },
      {
        "value": "6528",
        "label": "巴音郭楞蒙古自治州"
      },
      {
        "value": "6529",
        "label": "阿克苏地区"
      },
      {
        "value": "6530",
        "label": "克孜勒苏柯尔克孜自治州"
      },
      {
        "value": "6531",
        "label": "喀什地区"
      },
      {
        "value": "6532",
        "label": "和田地区"
      },
      {
        "value": "6540",
        "label": "伊犁哈萨克自治州"
      },
      {
        "value": "6542",
        "label": "塔城地区"
      },
      {
        "value": "6543",
        "label": "阿勒泰地区"
      },
      {
        "value": "659001",
        "label": "石河子市"
      },
      {
        "value": "659002",
        "label": "阿拉尔市"
      },
      {
        "value": "659003",
        "label": "图木舒克市"
      },
      {
        "value": "659004",
        "label": "五家渠市"
      },
      {
        "value": "659005",
        "label": "北屯市"
      },
      {
        "value": "659006",
        "label": "铁门关市"
      },
      {
        "value": "659007",
        "label": "双河市"
      },
      {
        "value": "659008",
        "label": "可克达拉市"
      },
      {
        "value": "659009",
        "label": "昆玉市"
      },
      {
        "value": "659010",
        "label": "胡杨河市"
      },
      {
        "value": "659011",
        "label": "新星市"
      },
      {
        "value": "659012",
        "label": "白杨市"
      }
    ]
  }
].filter(item => item.enable);